import React from 'react';
import { Button } from '@components';
import { Card, Form, Row, Col, ButtonGroup } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { DONVIDAOTAO_API } from '@app/utils/apiUrl.js';
import { useMutation } from 'react-query';
import { Post } from '@app/utils/httpProvider';
import { messageToast, status200, status201 } from '@app/utils/define';

const schema = yup.object().shape({
    tenDonViDaoTao: yup.string().required('Tên đơn vị đào tạo không được để trống')
});

const DonViDaoTaoAdd = () => {
    const history = useHistory();

    const addFunc = useMutation((value) => Post(DONVIDAOTAO_API.ADD_ITEM, null, value, false));

    const handleCreate = async (values) => {
        addFunc.mutate(values, {
            onSuccess: (res) => {
                if (res && (res.status === status200 || res.status === status201)) {
                    toast.success(messageToast.messageToastCreateSuccess);
                    history.goBack();
                } else {
                    toast.error(messageToast.messageToastCreateError);
                }
            },
            onError: (err) => {
                toast.error(err?.message || 'Đã có lỗi xảy ra, vui lòng thử lại!');
            }
        });
    };

    return (
        <Card>
            <Card.Header as="h5">Thêm đơn vị đào tạo</Card.Header>
            <Card.Body>
                <Formik
                    validationSchema={schema}
                    onSubmit={(values) => handleCreate(values)}
                    initialValues={{
                        tenDonViDaoTao: ''
                    }}
                >
                    {({ handleSubmit, handleChange, values, errors }) => (
                        <Form noValidate onSubmit={handleSubmit}>
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label className="col-sm-2 col-form-label">
                                    Tên đơn vị đào tạo
                                </Form.Label>
                                <Col sm="10">
                                    <Form.Control
                                        placeholder="Nhập tên đơn vị đào tạo"
                                        type="text"
                                        name="tenDonViDaoTao"
                                        value={values.tenDonViDaoTao}
                                        onChange={handleChange}
                                        isInvalid={!!errors.tenDonViDaoTao}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.tenDonViDaoTao}
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} className="mb-3">
                                <Col md={{ span: 10, offset: 2 }}>
                                    <ButtonGroup>
                                        <Button type="submit" theme="primary" disabled={addFunc.isLoading}>
                                            Thêm
                                        </Button>
                                        <Button
                                            type="button"
                                            theme="secondary"
                                            onClick={() => history.goBack()}
                                        >
                                            Hủy
                                        </Button>
                                    </ButtonGroup>
                                </Col>
                            </Form.Group>
                        </Form>
                    )}
                </Formik>
            </Card.Body>
        </Card>
    );
};

export default DonViDaoTaoAdd;
